import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";

import Markdown from "@src/components/Markdown";
// import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

interface Props {
  title: string;
  content: string;
}

const AboutGeneric: FC<Props> = ({ title, content }) => {
  return (
    <Stack sx={{ maxWidth: "1080px", margin: "0 auto" }}>
      <Typography
        variant="h2"
        sx={{
          marginBottom: 3,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h6"
        component="span"
        sx={{
          "& p": {
            margin: "0",
          },
        }}
      >
        <Markdown content={content} />
      </Typography>
    </Stack>
  );
};

export default AboutGeneric;
